var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.section
    ? _c(
        "div",
        { staticClass: "w-full flex flex-col items-center gap-5" },
        [
          _c(
            "div",
            {
              staticClass:
                "form-section w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-red-salmon rounded-xl",
              attrs: { id: "section_field_" + _vm.section.id }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nameInput,
                    expression: "nameInput"
                  }
                ],
                staticClass: "name-input mb-2 focus:border-light-purple",
                attrs: {
                  type: "text",
                  name: "section_name_" + _vm.section.id,
                  id: "section_name_" + _vm.section.id,
                  placeholder: "Section name"
                },
                domProps: { value: _vm.nameInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nameInput = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.descriptionInput,
                    expression: "descriptionInput"
                  }
                ],
                staticClass: "description-input focus:border-light-purple",
                attrs: {
                  type: "text",
                  name: "section_description_" + _vm.section.id,
                  id: "section_description_" + _vm.section.id,
                  placeholder: "Description (optional)"
                },
                domProps: { value: _vm.descriptionInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.descriptionInput = $event.target.value
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.section.questions, function(question) {
            return _c("ParentFormQuestion", {
              key: question.id,
              attrs: { question: question }
            })
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05586b3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05586b3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/salesPipeline/parentForm/Section.vue
// module id = null
// module chunks = 